import PropTypes from 'prop-types';

// PropTypes-Provider.js

export const RequestErrors = PropTypes.shape({
  service: PropTypes.shape({
    description: PropTypes.string,
    needDate: PropTypes.string,
    probDate: PropTypes.string,
    service: PropTypes.string
  }),
  provider: PropTypes.shape({
    // providers: PropTypes.string
    providers: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  }),
  approver: PropTypes.shape({
    approvers: PropTypes.string
  }),
  communicate: PropTypes.shape({
    receivers: PropTypes.string
  })
});

export const RequestTouched = PropTypes.shape({
  service: PropTypes.shape({
    service: PropTypes.bool,
    probDate: PropTypes.bool,
    needDate: PropTypes.bool,
    description: PropTypes.bool
  })
});

export const RequestField = PropTypes.string;

export const RequestValue = PropTypes.shape({
  accordionStep: PropTypes.number,
  service: PropTypes.shape({
    service: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      value: PropTypes.number,
      label: PropTypes.string
    }),
    probDate: PropTypes.string,
    needDate: PropTypes.string,
    description: PropTypes.string
  }),
  provider: PropTypes.shape({
    providers: PropTypes.arrayOf(
      PropTypes.shape({
        businessUnit: PropTypes.shape({
          id: PropTypes.number,
          nombre: PropTypes.string,
          value: PropTypes.number,
          label: PropTypes.string
        })
      })
    )
  }),
  approver: PropTypes.shape({
    approvers: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  communicate: PropTypes.shape({
    receivers: PropTypes.arrayOf(PropTypes.shape({})),
    aditionalReceivers: PropTypes.arrayOf(PropTypes.shape({}))
  })
});
